// extracted by mini-css-extract-plugin
export var aircallIframe = "_kn-3";
export var fabContainer = "_kn-5";
export var fabRinging = "_kn-6";
export var loadingOverlay = "_kn-4";
export var pulse = "_kn-7";
export var widgetContent = "_kn-2";
export var widgetPanel = "_kn-0";
export var widgetPanelExpanded = "_kn-1";